// plugin.ts
import { DomEditor } from "@wangeditor/editor";

function editorPlugin(editor) {
  const { insertText, isInline, isVoid } = editor;
  const newEditor = editor;

  // 重写 insertText
  newEditor.insertText = (t) => {
    // 选过选中了 void 元素
    const elems = DomEditor.getSelectedElems(newEditor);
    const isSelectedVoidElem = elems.some((elem) => newEditor.isVoid(elem));
    if (isSelectedVoidElem) {
      insertText(t);
      return;
    }

    insertText(t);
  };

  // 重写 isInline
  newEditor.isInline = (elem) => {
    const type = DomEditor.getNodeType(elem);
    if (type === "videoAttachment") {
      return true;
    }

    if (type === "fileAttachment") {
      return true;
    }

    return isInline(elem);
  };

  // 重写 isVoid
  newEditor.isVoid = (elem) => {
    const type = DomEditor.getNodeType(elem);
    if (type === "videoAttachment") {
      return true;
    }

    if (type === "fileAttachment") {
      return true;
    }

    return isVoid(elem);
  };

  return newEditor;
}

export default editorPlugin;
